export const INITIATE_TRANSACTION = "INITIATE_TRANSACTION";
export const VALIDATE_TRANSACTION = "VALIDATE_TRANSACTION";
export const UPDATE_NAVIGATION = "UPDATE_NAVIGATION";
export const UPDATE_TRANSACTION_DATA = "UPDATE_TRANSACTION_DATA";
export const CLEAR_TRANSACTION_DATA = "CLEAR_TRANSACTION_DATA";
export const TRANSACTION_FAILED = "TRANSACTION_FAILED";
export const UPDATE_INIT_TRANSACTION = "UPDATE_INIT_TRANSACTION";
export const UPDATE_INIT_TRANSACTION_COMPLETED = "UPDATE_INIT_TRANSACTION_COMPLETED";
export const REMOVE_CONTRACTOR_ID_FROM_PERSIST = "REMOVE_CONTRACTOR_ID_FROM_PERSIST";
export const ADD_CONTRACTOR_ID_FROM_PERSIST = "ADD_CONTRACTOR_ID_FROM_PERSIST";
export const UPDATE_ALREADY_PAYMENT_INITIATED = "UPDATE_ALREADY_PAYMENT_INITIATED";
export const GENERATE_FULL_WARRANTY = "GENERATE_FULL_WARRANTY";
export const GENERATE_FULL_WARRANTY_DOWNLOADED = "GENERATE_FULL_WARRANTY_DOWNLOADED";
export const GENERATE_SUMMARY_WARRANTY = "GENERATE_SUMMARY_WARRANTY";
export const GENERATE_SUMMARY_WARRANTY_DOWNLOADED = "GENERATE_SUMMARY_WARRANTY_DOWNLOADED";
export const DOWNLOAD_SUMMARY_PDF = "DOWNLOAD_SUMMARY_PDF";
export const DOWNLOAD_SUMMARY_PDF_SUCCESS = "DOWNLOAD_SUMMARY_PDF_SUCCESS";
export const DOWNLOAD_SUMMARY_PDF_FAILURE = "DOWNLOAD_SUMMARY_PDF_FAILURE";